<div class="c-form-element-checkbox-button01">
  <ng-container *ngIf="baggageDisplay.isDisplayStatus !== true; else displayStatus">
    <div
      [ngClass]="[
        'c-form-element-checkbox-button01',
        baggageDisplay.isActive ? '' : 'is-disabled',
        baggageDisplay.isSelected && baggageDisplay.isActive ? 'is-selected' : ''
      ]"
    >
      <div class="c-form-element-checkbox-button01__wrap">
        <input
          type="checkbox"
          name="checkbox{{ uuid }}_{{ airBoundId }}_{{ travelerId }}"
          [disabled]="baggageDisplay.isActive !== true"
          id="checkbox{{ uuid }}_{{ airBoundId }}_{{ travelerId }}"
          class="c-form-element-checkbox-button01__input"
          value="{{ travelerId }}"
          (change)="onCheckboxChange($event)"
          [checked]="baggageDisplay.isSelected"
        />
        <label
          for="checkbox{{ uuid }}_{{ airBoundId }}_{{ travelerId }}"
          class="c-form-element-checkbox-button01__label"
        >
          <span class="c-form-element-checkbox-button01__text c-form-element-checkbox-button01__text--has-status">
            <span class="c-form-element-checkbox-button01__text-label">{{ 'label.extraBaggage' | staticMsg }}</span>
            <span class="c-form-element-checkbox-button01__text-status" *ngIf="isShowAmount"
              ><span class="c-amount c-amount--price">
                {{ getServiceAmount }}
              </span></span
            >
          </span>
          <span class="c-form-element-checkbox-button01__check"></span>
        </label>
      </div>
    </div>
  </ng-container>
  <ng-template #displayStatus>
    <div class="p-input-block02__row-body-item">
      <div class="c-status-display">
        <span class="c-status-display__body c-status-display__body--has-status">
          <span class="c-status-display__text">
            <span class="c-status-display__text-label">{{ 'label.extraBaggage' | staticMsg }}</span>
          </span>
          <span
            class="c-status-display__status c-status-display__status--gray60"
            [innerHTML]="baggageDisplay.status"
          ></span>
        </span>
      </div>
    </div>
  </ng-template>
</div>
